var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstaIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    x2: 0,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5b4fe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.268,
    stopColor: "#c8379e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#f75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbe18a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12996",
    "data-name": "Group 12996",
    transform: "translate(-896 -562)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13122",
    "data-name": "Group 13122"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17739",
    "data-name": "Rectangle 17739",
    width: 40,
    height: 40,
    transform: "translate(896 562)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12996-2",
    "data-name": "Group 12996",
    transform: "translate(907 573)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 1.026,
    cy: 1.026,
    r: 1.026,
    transform: "translate(13.556 3.428)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17367",
    "data-name": "Path 17367",
    d: "M180.091,173.316a4.312,4.312,0,1,0,4.312,4.312A4.317,4.317,0,0,0,180.091,173.316Zm0,7.074a2.762,2.762,0,1,1,2.762-2.762A2.765,2.765,0,0,1,180.091,180.389Z",
    transform: "translate(-170.508 -168.128)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12994",
    "data-name": "Group 12994",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17368",
    "data-name": "Path 17368",
    d: "M102.834,107.449H95.248a5.713,5.713,0,0,1-5.707-5.707V94.156a5.713,5.713,0,0,1,5.707-5.707h7.586a5.714,5.714,0,0,1,5.707,5.707v7.586A5.714,5.714,0,0,1,102.834,107.449ZM95.248,90.236a3.924,3.924,0,0,0-3.92,3.92v7.586a3.924,3.924,0,0,0,3.92,3.92h7.586a3.924,3.924,0,0,0,3.92-3.92V94.156a3.924,3.924,0,0,0-3.92-3.92H95.248Z",
    transform: "translate(-89.541 -88.449)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/insta__icon.e67e00a7898ab660b07411c1d229f9d3.svg";
export { ForwardRef as ReactComponent };